// extracted by mini-css-extract-plugin
export default {"container":"errorBoundaryFallback_container__QCSQv"};